
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

import NotFoundComponent from "@/components/404.vue";
import { ViewAnalytics } from "@/mixins";
import { MetadataKeys } from "@/types";

@Component({
  components: {
    NotFoundComponent: NotFoundComponent,
  },
})
export default class NotFound extends mixins(ViewAnalytics) {
  // Override for PageTitle mixin
  pageName = "Error";

  mounted(): void {
    this.setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Error Page");
    this.pushPageViewEvent();
  }
}
